import React from "react";
import Navbar from "./Navbar";

function MainScreen({ children }) {
  return (
    <div>
      <Navbar />
      <div
        style={{
          marginTop: 10,
        }}
      >
        {children}
      </div>
    </div>
  );
}

export default MainScreen;
